import { VHCRecordCheckBrakeItemInput, VhcRecordLogService } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type UpdateBreakItemInput = {
  logId: number;
  itemId: number;
  requestBody?: VHCRecordCheckBrakeItemInput;
};

export const useUpdateBreakItemMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.putVhcRecordsItemsBrakes, UpdateBreakItemInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, requestBody }: UpdateBreakItemInput) =>
      VhcRecordLogService.putVhcRecordsItemsBrakes(logId, itemId, requestBody),
    options
  );
